import { render, staticRenderFns } from "./OptionBox.vue?vue&type=template&id=2da48c00&scoped=true&"
import script from "./OptionBox.vue?vue&type=script&lang=js&"
export * from "./OptionBox.vue?vue&type=script&lang=js&"
import style0 from "./OptionBox.vue?vue&type=style&index=0&id=2da48c00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da48c00",
  null
  
)

export default component.exports